import { render } from "./Blockchain.vue?vue&type=template&id=00c8da30"
import script from "./Blockchain.vue?vue&type=script&lang=js"
export * from "./Blockchain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__